export default {
	regular: {
		height: "32px",
		minHeight: "32px",
		"@media (min-width: 600px)": {
			minHeight: "48px",
		},
	},
};
